var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winCard",class:_vm.classObject},[_c('img',{attrs:{"src":require('./images/'+ _vm.card.id +'.png'),"alt":""},on:{"click":function($event){return _vm.setCard(_vm.card)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }